import { MutationTree } from 'vuex';
import { Device, DeviceState } from './types';
import { Error } from '../types';
import store from '../store';

export const mutations: MutationTree<DeviceState> = {
  GET_SUCCESS: (state, payload: Device[]) => {
    state.devices = payload;
  },
  GET_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'DEVICE_GET_ERROR_',
      error: payload.status,
    });
  },
  UPDATE_SUCCESS: (state) => {
    store.commit('alert/SHOW', { success: 'DEVICE_UPDATE_SUCCESS' });
  },
  UPDATE_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'DEVICE_UPDATE_ERROR_',
      error: payload.status,
    });
  },
  REBOOT_SUCCESS: (state) => {
    store.commit('alert/SHOW', { success: 'DEVICE_REBOOT_SUCCESS' });
  },
  REBOOT_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'DEVICE_REBOOT_ERROR_',
      error: payload.status,
    });
  },
  CONNECT_DEVICE_SUCCESS: (state, payload) => {
    if (payload && payload.https) {
      window.open(payload.https, '_blank');
    } else if (payload.http) {
      window.open(payload.http, '_blank');
    }
  },
  CONNECT_DEVICE_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'DEVICE_REBOOT_ERROR_',
      error: payload.status,
    });
  },
  UPDATE_FIRMWARE_SUCCESS: (state) => {
    store.commit('alert/SHOW', { success: 'UPDATE_FIRMWARE_SUCCESS' });
  },
  UPDATE_FIRMWARE_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'UPDATE_FIRMWARE_ERROR_',
      error: payload.status,
    });
  },
};
